import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "graphUp"
const GraphUpIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m12 11.586 5.293-5.293-1.581-1.581c-.393-.393-.265-.801.268-.908L22.5 2.5l-1.304 6.52c-.108.541-.519.657-.908.268l-1.58-1.58L12 14.413l-4-4-5.293 5.293a1 1 0 0 1-1.414-1.414L8 7.586l4 4ZM8 22v-9.464l-4 4V22h4Zm6 0v-7.464l-2 2-2-2V22h4Zm6 0V11.118a1.552 1.552 0 0 1-.06-.057l-1.233-1.233L16 12.536V22h4Z"
      />
    </svg>
  )
}
export default GraphUpIcon
